module.exports = __webpack_public_path__ + "static/img/day-4.7d2b8e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-4.png
// module id = /4Hz
// module chunks = 1